import { startOfDay, endOfDay, subYears } from 'date-fns'
import { INTERNAL_API_ROOT } from '../../config/api'
import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { pagedResponse, pagedPaymentResponse } from '../../utils/pagedResponse'
import {
  infoNotification,
  errorNotification,
  successNotification,
} from '../application/notifications'

// TYPES & ACTIONS
export const GET_ORGANIZATION_DETAIL_OPTIONS_REQUEST = 'GET_ORGANIZATION_DETAIL_OPTIONS_REQUEST'
export const GET_ORGANIZATION_DETAIL_OPTIONS_SUCCESS = 'GET_ORGANIZATION_DETAIL_OPTIONS_SUCCESS'
export const GET_ORGANIZATION_DETAIL_OPTIONS_FAILURE = 'GET_ORGANIZATION_DETAIL_OPTIONS_FAILURE'

export const getOrganizationDetailOptions = () => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/options`,
      types: [
        GET_ORGANIZATION_DETAIL_OPTIONS_REQUEST,
        GET_ORGANIZATION_DETAIL_OPTIONS_SUCCESS,
        GET_ORGANIZATION_DETAIL_OPTIONS_FAILURE,
      ],
    },
  })
}

export const GET_ORGANIZATION_DETAILS_REQUEST = 'GET_ORGANIZATION_DETAILS_REQUEST'
export const GET_ORGANIZATION_DETAILS_SUCCESS = 'GET_ORGANIZATION_DETAILS_SUCCESS'
export const GET_ORGANIZATION_DETAILS_FAILURE = 'GET_ORGANIZATION_DETAILS_FAILURE'
export const RESET_GET_ORGANIZATION_DETAIL_ERROR = 'RESET_GET_ORGANIZATION_DETAIL_ERROR'

export const getOrganizationDetails = id => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${id}/details`,
      types: [
        GET_ORGANIZATION_DETAILS_REQUEST,
        GET_ORGANIZATION_DETAILS_SUCCESS,
        GET_ORGANIZATION_DETAILS_FAILURE,
      ],
    },
  })
}

export const PUT_ORGANIZATION_DETAILS_REQUEST = 'PUT_ORGANIZATION_DETAILS_REQUEST'
export const PUT_ORGANIZATION_DETAILS_SUCCESS = 'PUT_ORGANIZATION_DETAILS_SUCCESS'
export const PUT_ORGANIZATION_DETAILS_FAILURE = 'PUT_ORGANIZATION_DETAILS_FAILURE'

export const putOrganizationDetails = (id, details) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PUT',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${id}/details`,
      types: [
        PUT_ORGANIZATION_DETAILS_REQUEST,
        PUT_ORGANIZATION_DETAILS_SUCCESS,
        PUT_ORGANIZATION_DETAILS_FAILURE,
      ],
      body: JSON.stringify(details),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: response?.payload?.response.messages[0],
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const GET_ORGANIZATION_FEATURES_REQUEST = 'GET_ORGANIZATION_FEATURES_REQUEST'
export const GET_ORGANIZATION_FEATURES_SUCCESS = 'GET_ORGANIZATION_FEATURES_SUCCESS'
export const GET_ORGANIZATION_FEATURES_FAILURE = 'GET_ORGANIZATION_FEATURES_FAILURE'

export const getOrganizationFeatures = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/features`,
      types: [
        GET_ORGANIZATION_FEATURES_REQUEST,
        GET_ORGANIZATION_FEATURES_SUCCESS,
        GET_ORGANIZATION_FEATURES_FAILURE,
      ],
    },
  })
}

export const PATCH_ORGANIZATION_FEATURES_REQUEST = 'PATCH_ORGANIZATION_FEATURES_REQUEST'
export const PATCH_ORGANIZATION_FEATURES_SUCCESS = 'PATCH_ORGANIZATION_FEATURES_SUCCESS'
export const PATCH_ORGANIZATION_FEATURES_FAILURE = 'PATCH_ORGANIZATION_FEATURES_FAILURE'

export const patchOrganizationFeatures = (id, features) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PATCH',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${id}/features`,
      types: [
        PATCH_ORGANIZATION_FEATURES_REQUEST,
        PATCH_ORGANIZATION_FEATURES_SUCCESS,
        PATCH_ORGANIZATION_FEATURES_FAILURE,
      ],
      body: JSON.stringify(features),
    },
  })
}

export const GET_ORGANIZATION_TEAM_MEMBERS_REQUEST = 'GET_ORGANIZATION_TEAM_MEMBERS_REQUEST'
export const GET_ORGANIZATION_TEAM_MEMBERS_SUCCESS = 'GET_ORGANIZATION_TEAM_MEMBERS_SUCCESS'
export const GET_ORGANIZATION_TEAM_MEMBERS_FAILURE = 'GET_ORGANIZATION_TEAM_MEMBERS_FAILURE'

export const getOrganizationTeamMembers = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/teamMembers`,
      types: [
        GET_ORGANIZATION_TEAM_MEMBERS_REQUEST,
        GET_ORGANIZATION_TEAM_MEMBERS_SUCCESS,
        GET_ORGANIZATION_TEAM_MEMBERS_FAILURE,
      ],
    },
  })
}

export const GET_ORGANIZATION_PAYMENT_INFO_REQUEST = 'GET_ORGANIZATION_PAYMENT_INFO_REQUEST'
export const GET_ORGANIZATION_PAYMENT_INFO_SUCCESS = 'GET_ORGANIZATION_PAYMENT_INFO_SUCCESS'
export const GET_ORGANIZATION_PAYMENT_INFO_FAILURE = 'GET_ORGANIZATION_PAYMENT_INFO_FAILURE'

export const getOrganizationPaymentInfo = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/paymentInfo`,
      types: [
        GET_ORGANIZATION_PAYMENT_INFO_REQUEST,
        GET_ORGANIZATION_PAYMENT_INFO_SUCCESS,
        GET_ORGANIZATION_PAYMENT_INFO_FAILURE,
      ],
    },
  })
}

export const GET_ORGANIZATION_PROJECTS_REQUEST = 'GET_ORGANIZATION_PROJECTS_REQUEST'
export const GET_ORGANIZATION_PROJECTS_SUCCESS = 'GET_ORGANIZATION_PROJECTS_SUCCESS'
export const GET_ORGANIZATION_PROJECTS_FAILURE = 'GET_ORGANIZATION_PROJECTS_FAILURE'

export const getOrganizationProjects = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/projects/list`,
      types: [
        GET_ORGANIZATION_PROJECTS_REQUEST,
        GET_ORGANIZATION_PROJECTS_SUCCESS,
        GET_ORGANIZATION_PROJECTS_FAILURE,
      ],
    },
  })
}

export const DELETE_ORGANIZATION_PROJECTS_VOTES_REQUEST =
  'DELETE_ORGANIZATION_PROJECTS_VOTES_REQUEST'
export const DELETE_ORGANIZATION_PROJECTS_VOTES_SUCCESS =
  'DELETE_ORGANIZATION_PROJECTS_VOTES_SUCCESS'
export const DELETE_ORGANIZATION_PROJECTS_VOTES_FAILURE =
  'DELETE_ORGANIZATION_PROJECTS_VOTES_FAILURE'

export const deleteOrganizationProjectsVotes = (organizationId, projectId) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/projects/${projectId}/galleryvotes`,
      types: [
        DELETE_ORGANIZATION_PROJECTS_VOTES_REQUEST,
        DELETE_ORGANIZATION_PROJECTS_VOTES_SUCCESS,
        DELETE_ORGANIZATION_PROJECTS_VOTES_FAILURE,
      ],
    },
  })
}

export const GET_ORGANIZATION_SUBMISSIONS_REQUEST = 'GET_ORGANIZATION_SUBMISSIONS_REQUEST'
export const GET_ORGANIZATION_SUBMISSIONS_SUCCESS = 'GET_ORGANIZATION_SUBMISSIONS_SUCCESS'
export const GET_ORGANIZATION_SUBMISSIONS_FAILURE = 'GET_ORGANIZATION_SUBMISSIONS_FAILURE'

export const getOrganizationSubmissions =
  (organizationId, page = 1) =>
  dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/submissions?organizationId=${organizationId}&page=${page}&sortBy.field=Date&sortBy.order=descending`,
        types: [
          GET_ORGANIZATION_SUBMISSIONS_REQUEST,
          GET_ORGANIZATION_SUBMISSIONS_SUCCESS,
          GET_ORGANIZATION_SUBMISSIONS_FAILURE,
        ],
      },
    })
  }

export const GET_ORGANIZATION_FORM_VISIT_REQUEST = 'GET_ORGANIZATION_FORM_VISIT_REQUEST'
export const GET_ORGANIZATION_FORM_VISIT_SUCCESS = 'GET_ORGANIZATION_FORM_VISIT_SUCCESS'
export const GET_ORGANIZATION_FORM_VISIT_FAILURE = 'GET_ORGANIZATION_FORM_VISIT_FAILURE'

export const getOrganizationFormVisits = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/formVisits`,
      types: [
        GET_ORGANIZATION_FORM_VISIT_REQUEST,
        GET_ORGANIZATION_FORM_VISIT_SUCCESS,
        GET_ORGANIZATION_FORM_VISIT_FAILURE,
      ],
    },
  })
}

export const GET_ORGANIZATION_PAYMENTS_REQUEST = 'GET_ORGANIZATION_PAYMENTS_REQUEST'
export const GET_ORGANIZATION_PAYMENTS_SUCCESS = 'GET_ORGANIZATION_PAYMENTS_SUCCESS'
export const GET_ORGANIZATION_PAYMENTS_FAILURE = 'GET_ORGANIZATION_PAYMENTS_FAILURE'

export const getOrganizationPayments =
  (organizationId, dateRange, page = 1, limit = 20) =>
  dispatch => {
    let cleanedRange = dateRange
    if (dateRange == null) {
      cleanedRange = [null, null]
    }
    if (cleanedRange[0] == null) {
      cleanedRange[0] = subYears(new Date(), 100)
    }
    if (cleanedRange[1] == null) {
      cleanedRange[1] = new Date()
    }

    const startDate = startOfDay(cleanedRange[0]).toJSON()
    const endDate = endOfDay(cleanedRange[1]).toJSON()

    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/payments?pageSize=${limit}&page=${page}&start=${startDate}&end=${endDate}`,
        types: [
          GET_ORGANIZATION_PAYMENTS_REQUEST,
          GET_ORGANIZATION_PAYMENTS_SUCCESS,
          GET_ORGANIZATION_PAYMENTS_FAILURE,
        ],
      },
    })
  }

export const DOWNLOAD_ORGANIZATION_PAYMENTS_REQUEST = 'DOWNLOAD_ORGANIZATION_PAYMENTS_REQUEST'
export const DOWNLOAD_ORGANIZATION_PAYMENTS_SUCCESS = 'DOWNLOAD_ORGANIZATION_PAYMENTS_SUCCESS'
export const DOWNLOAD_ORGANIZATION_PAYMENTS_FAILURE = 'DOWNLOAD_ORGANIZATION_PAYMENTS_FAILURE'

export const downloadOrganizationPayments = (organizationId, dateRange) => async dispatch => {
  let cleanedRange = dateRange
  if (dateRange == null) {
    cleanedRange = [null, null]
  }
  if (cleanedRange[0] == null) {
    cleanedRange[0] = subYears(new Date(), 100)
  }
  if (cleanedRange[1] == null) {
    cleanedRange[1] = new Date()
  }

  const startDate = startOfDay(cleanedRange[0]).toJSON()
  const endDate = endOfDay(cleanedRange[1]).toJSON()

  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/payments/download?start=${startDate}&end=${endDate}`,
      types: [
        DOWNLOAD_ORGANIZATION_PAYMENTS_REQUEST,
        {
          type: DOWNLOAD_ORGANIZATION_PAYMENTS_SUCCESS,
          payload: (_, __, res) => {
            return res.blob()
          },
        },
        DOWNLOAD_ORGANIZATION_PAYMENTS_FAILURE,
      ],
    },
  }).then(response => {
    return response.payload
  })
}

export const GET_ORGANIZATION_ROLES_REQUEST = 'GET_ORGANIZATION_ROLES_REQUEST'
export const GET_ORGANIZATION_ROLES_SUCCESS = 'GET_ORGANIZATION_ROLES_SUCCESS'
export const GET_ORGANIZATION_ROLES_FAILURE = 'GET_ORGANIZATION_ROLES_FAILURE'
export const RESET_ORGANIZATION_ROLES_ERROR = 'RESET_ORGANIZATION_ROLES_ERROR'
export const getOrganizationRoles = orgId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgId}/roles`,
      types: [
        GET_ORGANIZATION_ROLES_REQUEST,
        GET_ORGANIZATION_ROLES_SUCCESS,
        GET_ORGANIZATION_ROLES_FAILURE,
      ],
    },
  })
}

export const CHANGE_TEAM_MEMBER_LEVEL_REQUEST = 'CHANGE_TEAM_MEMBER_LEVEL_REQUEST'
export const CHANGE_TEAM_MEMBER_LEVEL_SUCCESS = 'CHANGE_TEAM_MEMBER_LEVEL_SUCCESS'
export const CHANGE_TEAM_MEMBER_LEVEL_FAILURE = 'CHANGE_TEAM_MEMBER_LEVEL_FAILURE'

export const changeTeamMemberLevel = (teamMemberData, updateCallback) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      body: JSON.stringify(teamMemberData),
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${teamMemberData.organizationId}/teamMember/${teamMemberData.userId}/changelevel`,
      types: [
        CHANGE_TEAM_MEMBER_LEVEL_REQUEST,
        CHANGE_TEAM_MEMBER_LEVEL_SUCCESS,
        CHANGE_TEAM_MEMBER_LEVEL_FAILURE,
      ],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Unable to change team member level`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(updateCallback())
      dispatch(
        infoNotification({
          body: `Team Member Updated`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const REMOVE_TEAM_MEMBER_REQUEST = 'REMOVE_TEAM_MEMBER_REQUEST'
export const REMOVE_TEAM_MEMBER_SUCCESS = 'REMOVE_TEAM_MEMBER_SUCCESS'
export const REMOVE_TEAM_MEMBER_FAILURE = 'REMOVE_TEAM_MEMBER_FAILURE'
export const removeTeamMember = (email, organizationId, updateCallback) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/teamMembers?request.email=${encodeURIComponent(
        email
      )}`,
      types: [REMOVE_TEAM_MEMBER_REQUEST, REMOVE_TEAM_MEMBER_SUCCESS, REMOVE_TEAM_MEMBER_FAILURE],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: 'Unable to remove team member',
          dismissInSeconds: 10,
        })
      )
      return
    }

    updateCallback()
    dispatch(
      infoNotification({
        body: 'Team member removed',
        dismissInSeconds: 5,
      })
    )
  })
}

export const ADD_TEAM_MEMBER_REQUEST = 'ADD_TEAM_MEMBER_REQUEST'
export const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS'
export const ADD_TEAM_MEMBER_FAILURE = 'ADD_TEAM_MEMBER_FAILURE'

export const addTeamMember = (teamMemberData, organizationId, updateCallback) => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      body: JSON.stringify(teamMemberData),
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/teamMembers`,
      types: [ADD_TEAM_MEMBER_REQUEST, ADD_TEAM_MEMBER_SUCCESS, ADD_TEAM_MEMBER_FAILURE],
    },
  }).then(response => {
    if (response.error && response.payload.status === 404) {
      dispatch(
        errorNotification({
          body: `Could not find an existing user with the email: ${teamMemberData?.email}`,
          dismissInSeconds: 10,
        })
      )
      return
    }
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Unable to add team member - ${response.payload}`,
          dismissInSeconds: 10,
        })
      )
    } else {
      updateCallback()
      dispatch(
        infoNotification({
          body: 'Team member added',
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const GET_ORGANIZATION_PAYOUT_ACCOUNTS_REQUEST = 'GET_ORGANIZATION_PAYOUT_ACCOUNTS_REQUEST'
export const GET_ORGANIZATION_PAYOUT_ACCOUNTS_SUCCESS = 'GET_ORGANIZATION_PAYOUT_ACCOUNTS_SUCCESS'
export const GET_ORGANIZATION_PAYOUT_ACCOUNTS_FAILURE = 'GET_ORGANIZATION_FEATURES_FAILURE'

export const getOrganizationPayoutAccounts = organizationId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/payout`,
      types: [
        GET_ORGANIZATION_PAYOUT_ACCOUNTS_REQUEST,
        GET_ORGANIZATION_PAYOUT_ACCOUNTS_SUCCESS,
        GET_ORGANIZATION_PAYOUT_ACCOUNTS_FAILURE,
      ],
    },
  })
}

export const CREATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST =
  'CREATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST'
export const CREATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS =
  'CREATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS'
export const CREATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE =
  'CREATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE'

export const createOrganizationPayoutAccount =
  (organizationPayoutAccountData, callback) => dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'POST',
        body: JSON.stringify(organizationPayoutAccountData),
        endpoint: `${INTERNAL_API_ROOT}/admin/funds/payout`,
        types: [
          CREATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST,
          CREATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS,
          CREATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE,
        ],
      },
    }).then(response => {
      if (response.error) {
        dispatch(
          errorNotification({
            body: `Error creating organization payout accounts: ${response.payload.statusText}`,
            dismissInSeconds: 10,
          })
        )
      } else {
        dispatch(getOrganizationPayoutAccounts(organizationPayoutAccountData.organizationId))
        dispatch(callback)
        dispatch(
          successNotification({
            body: `Organization payout account successfully created`,
            dismissInSeconds: 5,
          })
        )
      }
    })
  }

export const UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST =
  'UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST'
export const UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS =
  'UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS'
export const UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE =
  'UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE'

export const updateOrganizationPayoutAccount =
  (organizationPayoutAccountData, callback) => dispatch => {
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'PUT',
        body: JSON.stringify(organizationPayoutAccountData),
        endpoint: `${INTERNAL_API_ROOT}/admin/funds/payout`,
        types: [
          UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_REQUEST,
          UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_SUCCESS,
          UPDATE_ORGANIZATION_PAYOUT_ACCOUNT_FAILURE,
        ],
      },
    }).then(response => {
      if (response.error) {
        dispatch(
          errorNotification({
            body: `Error updating organization payout account: ${response.payload.statusText}`,
            dismissInSeconds: 10,
          })
        )
      } else {
        dispatch(getOrganizationPayoutAccounts(organizationPayoutAccountData.organizationId))
        dispatch(callback)
        dispatch(
          successNotification({
            body: `Organization payout account successfully updated`,
            dismissInSeconds: 5,
          })
        )
      }
    })
  }

const PATCH_USER_ORGANIZATION_ROLES_REQUEST = 'PATCH_USER_ORGANIZATION_ROLES_REQUEST'
const PATCH_USER_ORGANIZATION_ROLES_SUCCESS = 'PATCH_USER_ORGANIZATION_ROLES_SUCCESS'
const PATCH_USER_ORGANIZATION_ROLES_FAILURE = 'PATCH_USER_ORGANIZATION_ROLES_FAILURE'

export const patchUserOrganizationRoles = (orgId, userId, payload) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PATCH',
      body: JSON.stringify(payload),
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgId}/teamMember/${userId}/roles`,
      types: [
        PATCH_USER_ORGANIZATION_ROLES_REQUEST,
        PATCH_USER_ORGANIZATION_ROLES_SUCCESS,
        PATCH_USER_ORGANIZATION_ROLES_FAILURE,
      ],
    },
  })
}

const GET_ORGANIZATION_TEAM_INVITES_REQUEST = 'GET_ORGANIZATION_TEAM_INVITES_REQUEST'
const GET_ORGANIZATION_TEAM_INVITES_SUCCESS = 'GET_ORGANIZATION_TEAM_INVITES_SUCCESS'
const GET_ORGANIZATION_TEAM_INVITES_FAILURE = 'GET_ORGANIZATION_TEAM_INVITES_FAILURE'
export const getOrganizationTeamInvites = organizationId => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${organizationId}/teamInvites`,
      types: [
        GET_ORGANIZATION_TEAM_INVITES_REQUEST,
        GET_ORGANIZATION_TEAM_INVITES_SUCCESS,
        GET_ORGANIZATION_TEAM_INVITES_FAILURE,
      ],
    },
  })
}

// SELECTORS
export const selectOrganizationDetails = state => state.submittable.organizationDetails
export const selectOrganizationDetailOptions = state => selectOrganizationDetails(state).options
export const selectOrganization = state => selectOrganizationDetails(state).organization
export const selectOrganizationId = state => selectOrganization(state).id
export const selectOrganizationFeatures = state => selectOrganizationDetails(state).features
export const selectOrganizationTeamMembers = state => selectOrganizationDetails(state).teamMembers
export const selectOrganizationProjects = state => selectOrganizationDetails(state).projects
export const selectOrganizationSubmissions = state => selectOrganizationDetails(state).submissions
export const selectOrganizationFormVisits = state => selectOrganizationDetails(state).formVisits
export const selectOrganizationPayments = state => selectOrganizationDetails(state).payments
export const selectOrganizationName = state => selectOrganizationDetails(state).organization.name
export const selectOrganizationPayoutAccounts = state =>
  selectOrganizationDetails(state).payoutAccounts
export const selectOrganizationPaymentInfo = state => selectOrganizationDetails(state).paymentInfo
export const selectOrganizationRoles = state => selectOrganizationDetails(state).orgRoles
export const selectUpdateUserOrgRoles = state => selectOrganizationDetails(state).updateUserRoles
export const selectOrganizationTeamInvites = state => selectOrganizationDetails(state).teamInvites

// STATE
const INITIAL_STATE = {
  options: {},
  organization: {
    isLoading: false,
    error: false,
  },
  teamInvites: {},
  submissionCounts: {},
  features: [],
  teamMembers: {
    teamMembersList: [],
    isLoading: false,
    error: false,
  },
  projects: {
    items: [],
    isLoading: false,
    error: false,
  },
  submissions: {
    ...pagedResponse,
  },
  formVisits: {
    ...pagedResponse,
  },
  payments: {
    ...pagedPaymentResponse,
  },
  payoutAccounts: [],
  paymentInfo: {
    isLoading: true,
  },
  orgRoles: {
    roles: [],
    isLoading: false,
    error: false,
  },
  updateUserRoles: {
    isLoading: false,
    error: false,
  },
}

// REDUCERS
const organizationDetails = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_ORGANIZATION_DETAIL_OPTIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      options: {
        ...newPayload,
      },
    }),
    [GET_ORGANIZATION_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      organization: {
        ...currentState.organization,
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
      organization: {
        ...newPayload.organization,
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_DETAILS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
      organization: {
        isLoading: false,
        error: {
          error: true,
          payload: newPayload,
        },
      },
    }),
    [RESET_GET_ORGANIZATION_DETAIL_ERROR]: currentState => ({
      ...currentState,
      organization: {
        ...currentState.organization,
        isLoading: false,
        error: false,
      },
    }),
    [PUT_ORGANIZATION_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      organization: {
        ...currentState.organization,
        createdAt: currentState.organization.createdAt,
        apiKey: currentState.organization.apiKey,
        numUnpaidSubmissions: currentState.organization.numUnpaidSubmissions,
        isLoading: true,
        error: false,
      },
    }),
    [PUT_ORGANIZATION_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organization: {
        ...currentState.organization,
        ...newPayload.organization,
        // we need to always set shouldTrackSubmissionsMonthly because this value if it is false it will not come
        // on BE response, which will keep the value from the currentState and lead into bad states
        shouldTrackSubmissionsMonthly: newPayload.organization.shouldTrackSubmissionsMonthly,
        live: newPayload.organization?.live ?? false,
        privateNotes: newPayload?.organization?.privateNotes ?? '',
        privateNotesUpdated: newPayload?.organization?.privateNotesUpdated ?? false,
        isLoading: false,
        error: false,
      },
    }),
    [PUT_ORGANIZATION_DETAILS_FAILURE]: currentState => ({
      ...currentState,
      organization: {
        ...currentState.organization,
        isLoading: false,
      },
    }),
    [GET_ORGANIZATION_FEATURES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      features: {
        ...newPayload,
      },
    }),
    [PATCH_ORGANIZATION_FEATURES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      features: {
        ...newPayload,
      },
    }),
    [GET_ORGANIZATION_TEAM_MEMBERS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      teamMembers: {
        teamMembersList: newPayload,
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_TEAM_MEMBERS_REQUEST]: currentState => ({
      ...currentState,
      teamMembers: {
        ...currentState.teamMembers.teamMembersList,
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_TEAM_MEMBERS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      teamMembers: {
        ...currentState.teamMembers.teamMembersList,
        isLoading: false,
        error: newPayload,
      },
    }),
    [GET_ORGANIZATION_PROJECTS_REQUEST]: currentState => ({
      ...currentState,
      projects: {
        ...currentState.projects,
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_PROJECTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      projects: {
        items: Array.isArray(newPayload) ? newPayload : [],
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_PROJECTS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      projects: {
        ...currentState.projects,
        isLoading: false,
        error: {
          error: true,
          details: newPayload,
        },
      },
    }),
    [GET_ORGANIZATION_SUBMISSIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      submissions: {
        ...newPayload,
      },
    }),
    [GET_ORGANIZATION_SUBMISSIONS_FAILURE]: currentState => ({
      ...currentState,
      submissions: { ...pagedResponse },
    }),
    [GET_ORGANIZATION_FORM_VISIT_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      formVisits: [...newPayload.formVisits],
    }),
    [GET_ORGANIZATION_PAYMENTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      payments: newPayload,
    }),
    [GET_ORGANIZATION_PAYOUT_ACCOUNTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      payoutAccounts: [...newPayload.payoutAccounts],
    }),
    [GET_ORGANIZATION_PAYMENT_INFO_REQUEST]: currentState => ({
      ...currentState,
      paymentInfo: {
        isLoading: true,
      },
    }),
    [GET_ORGANIZATION_PAYMENT_INFO_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      paymentInfo: {
        isLoading: false,
        ...newPayload.paymentInfo,
      },
    }),
    [GET_ORGANIZATION_PAYMENT_INFO_FAILURE]: currentState => ({
      ...currentState,
      paymentInfo: {
        isLoading: false,
      },
    }),
    [GET_ORGANIZATION_ROLES_REQUEST]: currentState => ({
      ...currentState,
      orgRoles: {
        roles: [],
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_ROLES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      orgRoles: {
        roles: newPayload,
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_ROLES_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      orgRoles: {
        roles: [],
        isLoading: false,
        error: { error: true, details: newPayload },
      },
    }),
    [RESET_ORGANIZATION_ROLES_ERROR]: currentState => ({
      ...currentState,
      orgRoles: {
        roles: [],
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_TEAM_INVITES_REQUEST]: currentState => ({
      ...currentState,
      teamInvites: {},
      organization: {
        ...currentState.organization,
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_TEAM_INVITES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      teamInvites: newPayload,
      organization: {
        ...currentState.organization,
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_TEAM_INVITES_FAILURE]: currentState => ({
      ...currentState,
      teamInvites: {},
      organization: {
        ...currentState.organization,
        // TODO: need to handle error case when org details are fetched but invites have failed to load.
        error: false,
        isLoading: false,
      },
    }),
  }[type]?.(state, payload) || state)

export default organizationDetails
